import React from 'react'
import { KycVerifyDetails } from '../../components'
import "./kycVerification.scss"
import { useLocation } from 'react-router-dom';

const KycVerification = () => {

  const location = useLocation();
  const { kycLink } = location.state || {};

  return (
    <div className=''>
      <KycVerifyDetails kycLink={kycLink} />
    </div>
  )
}

export default KycVerification